import { Injectable } from '@angular/core'
import { MatPaginatorIntl } from '@angular/material/paginator'

@Injectable()
export class CustomPaginator extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Nombre par page';
  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const amountPages = Math.ceil(length / pageSize)
    const firstElement = page * pageSize + 1
    const lastElement = Math.min((page + 1) * pageSize, length)

    let label = `Nb de résultat ${firstElement} à ${lastElement} - sur ${length}`

    if (length < pageSize) return label

    return `Page : ${page + 1} / ${amountPages} - ${label}`
  }
}
